var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgAllArrangements(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 103,
    viewBox: "0 0 84 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 72,
    height: 82,
    rx: 2,
    fill: "#FFEADB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 29,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 36,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 43,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 56,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 63,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 72,
    height: 82,
    rx: 2,
    fill: "#FF9D5A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 21,
    width: 72,
    height: 82,
    rx: 2,
    fill: "#FFEADB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 41,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 48,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 55,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 68,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 75,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 9V7.25C35 4.07436 32.4256 1.5 29.25 1.5V1.5C26.0744 1.5 23.5 4.07436 23.5 7.25V29C23.5 30.933 25.067 32.5 27 32.5V32.5C28.933 32.5 30.5 30.933 30.5 29V18",
    stroke: "#E62645",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAllArrangements);
export default __webpack_public_path__ + "static/media/imgAllArrangements.ef3f048785db33e8a2ed652f0769031e.svg";
export { ForwardRef as ReactComponent };